import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10" }
const _hoisted_2 = { class: "flex flex-col h-full justify-between text-white" }
const _hoisted_3 = { class: "flex-grow grid grid-rows-5" }
const _hoisted_4 = { class: "flex flex-col text-white text-4xl pl-12 pt-14" }
const _hoisted_5 = {
  key: 0,
  class: "py-4"
}
const _hoisted_6 = { class: "py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_ProfileMenuButton = _resolveComponent("ProfileMenuButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.showHome)
            ? (_openBlock(), _createBlock(_component_MenuButton, {
                key: 0,
                to: {name:'Home'},
                iconClass: "icon-home",
                tooltip: "Home"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ProfileMenuButton, {
            class: "row-start-5",
            notification: _ctx.meCounters?.notification_counter > 0
          }, null, 8, ["notification"])
        ])
      ])
    ]),
    (_ctx.$store.state.menu_visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "lg:hidden fixed z-10 inset-0 bg-gray-500 bg-opacity-90",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.showHome)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[2] || (_cache[2] = _createElementVNode("i", { class: "self-center text-md icon-home" }, null, -1)),
                  _createVNode(_component_router_link, {
                    to: {name:'Home'},
                    class: "pl-4"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("HOME")
                    ])),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "self-center fa fa-circle text-md" }, null, -1)),
              _createVNode(_component_router_link, {
                to: {name:'ProfiloUtente'},
                class: "pl-4"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("PROFILO")
                ])),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}